import { Component, Input, OnInit } from '@angular/core';
import { ModalAuctionSeeBidderInfoService } from '../../services/modal-auction-see-bidder-info/modal-auction-see-bidder-info.service';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-auction-see-bidder-info-modal',
  templateUrl: './auction-see-bidder-info-modal.component.html',
  styleUrls: ['./auction-see-bidder-info-modal.component.scss']
})
export class AuctionSeeBidderInfoModalComponent implements OnInit {

  @Input () data

  public auctionBidderInfoForm: UntypedFormGroup = null;

  public userInfo: any = null;
  public campaign: any = null;

  public nameInput: any = null;
  public emailInput: any = null;
  public phoneInput: any = null;
  public addressInput: any = null;
  public addInfoInput: any = null;
  public addInfoSelectInput: any = null;

  constructor(
    public modalAuctionSeeBidderInfoService: ModalAuctionSeeBidderInfoService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.userInfo = this.data.item.userInfo
    this.campaign = this.data.auctionCampaign

    this.auctionBidderInfoForm = this.fb.group({
      'nameInput': [''],
      'emailInput': ['', [
        Validators.required, 
        Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)
      ]],
      'phoneInput': [''],
      'addressInput': [''],
      'addInfoInput': [''],
      'addInfoSelectInput': [''],
    });

    this.nameInput = this.auctionBidderInfoForm.get('nameInput')
    this.emailInput = this.auctionBidderInfoForm.get('emailInput')
    this.addressInput = this.auctionBidderInfoForm.get('addressInput')
    this.phoneInput = this.auctionBidderInfoForm.get('phoneInput')
    this.addInfoInput = this.auctionBidderInfoForm.get('addInfoInput')
    this.addInfoSelectInput = this.auctionBidderInfoForm.get('addInfoSelectInput')

    this.nameInput.setValue(this.userInfo.name)
    this.emailInput.setValue(this.userInfo.email)
    const addressText = window['utils'].getStreetAddressText(this.userInfo.address);
    this.addressInput.setValue(addressText)
    this.phoneInput.setValue(this.userInfo.phone)
    this.addInfoInput.setValue(this.data.item.additionalInfo)
    this.addInfoSelectInput.setValue(this.data.item.additionalInfoSelect)
  }

  close() {
    this.modalAuctionSeeBidderInfoService.close();
  }
}
